import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import AppIconImage from './AppIconImage.js';
import styles from './index.module.scss.js';

var AppIcon = function (_a) {
    var assetEndpoint = _a.assetEndpoint, name = _a.name, _b = _a.appName, appName = _b === void 0 ? "" : _b, url = _a.url, platformId = _a.platformId, icon = _a.icon;
    return (jsx("a", __assign({ target: "_blank", href: url, rel: "noreferrer" }, { children: jsxs("div", __assign({ className: styles.appIcon }, { children: [jsx(AppIconImage, { assetEndpoint: assetEndpoint, alt: "".concat(name).concat(appName && "(".concat(appName, ")")), platformId: platformId, appIcon: icon }, void 0), jsxs("span", { children: [name, appName && (jsxs(Fragment, { children: [jsx("br", {}, void 0), "(", appName, ")"] }, void 0))] }, void 0)] }), void 0) }), void 0));
};

export { AppIcon as default };
